import { render } from "./PaginaLogin.vue?vue&type=template&id=3b60fec6"
import script from "./PaginaLogin.vue?vue&type=script&lang=js"
export * from "./PaginaLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__